const baseUrl = process.env.REACT_APP_BASE_URL_API;

export const apiPath = {
  readCountryList: `${baseUrl}/address/readCountryList`,
  readNationalityList: `${baseUrl}/address/readNationalityList`,
  checkTourAndBoatAndDateAvailable: `${baseUrl}/register/checkTourAndBoatAndDateAvailable`,
  readTourAndBoatDetail: `${baseUrl}/register/readTourAndBoatDetail`,
  readGenderOption: `${baseUrl}/register/readGenderOption`,
  deToken: `${baseUrl}/register/deToken`,
  submitPassenger: `${baseUrl}/register/submitPassenger`,
  checkUpdateTranslation: `${baseUrl}/translation/checkUpdateTranslation`,
  translationJson: `${baseUrl}/translation/translationJson`,
  readPortAndTourByIdProject: `${baseUrl}/tour/port`,
  login: `${baseUrl}/auth/login`,
  checkCompanyExist: `${baseUrl}/auth/checkCompanyExist`,
};
